var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"svgPic",attrs:{"id":_vm.svgId},on:{"click":_vm.openSeqRegionDetail}}),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.bigSVG,"visible":_vm.showSVG},on:{"update:visible":function($event){_vm.showSVG=$event}}},[_c('div',{staticClass:"big-svgpic",attrs:{"id":'big-' + _vm.svgId}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-792660e3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/svgPicture.vue
// module id = null
// module chunks = 